export default __webpack_public_path__ + "static/media/lincoln.f14a3eef.svg";